import React, { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import './nodeStyles.css';

export interface JDNodeData {
  wordCount: number;
  isValid: boolean;
  isInvalid: boolean;
  isSelected: boolean;
  onClick: () => void;
}

const JDNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { wordCount, isValid, isInvalid, onClick } = data as unknown as JDNodeData;
  
  return (
    <div
      className={`rf-node rf-node--jd-trigger ${
        selected ? 'rf-node--selected' : ''
      } ${
        isValid ? 'rf-node--valid' : ''
      } ${
        isInvalid ? 'rf-node--invalid' : ''
      }`}
      onClick={onClick}
    >
      {/* Trigger badge */}
      <div className="rf-trigger-badge">
        <span className="rf-trigger-badge__dot"></span>
        <span className="rf-trigger-badge__text">Trigger</span>
      </div>
      
      {/* Pill-shaped card */}
      <div className={`rf-pill rf-pill--trigger ${
        selected ? 'rf-pill--selected' : ''
      } ${
        isValid ? 'rf-pill--valid' : ''
      } ${
        isInvalid ? 'rf-pill--invalid' : ''
      }`}>
        {/* Icon on left */}
        <div className="rf-pill__icon rf-pill__icon--trigger">
          <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            <line x1="9" y1="12" x2="15" y2="12" />
            <line x1="9" y1="16" x2="15" y2="16" />
          </svg>
        </div>
        
        {/* Two-row text content */}
        <div className="rf-pill__content">
          <span className="rf-pill__title rf-pill__title--trigger">Job Description</span>
          <span className="rf-pill__subtitle rf-pill__subtitle--trigger">
            {wordCount > 0 ? `${wordCount} words` : 'Add JD to start'}
          </span>
        </div>
        
        {/* Word count badge */}
        {wordCount > 0 && (
          <span className={`rf-pill__badge ${isValid ? 'rf-pill__badge--valid' : ''} ${isInvalid ? 'rf-pill__badge--invalid' : ''}`}>
            {isValid ? '✓' : isInvalid ? '!' : wordCount}
          </span>
        )}
      </div>
      
      {/* Source handle on right side - connects to both branches */}
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        className="rf-handle rf-handle--source rf-handle--trigger-right"
      />
    </div>
  );
};

export default memo(JDNode);
